import * as React from "react";
import { PriceSection } from "./PriceSection.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const PriceSectionContainer = ({
  shouldDisplayFromPrice,
  fromPricePrefix
}) => {
  const { activeVariant, displayPrice } = useProductData();
  return /* @__PURE__ */ React.createElement(
    PriceSection,
    {
      originalPrice: displayPrice.originalPrice,
      orignalPriceCurrencyCode: displayPrice.currency,
      discountedPrice: displayPrice.discountedPrice,
      discountBadge: displayPrice.discountInfo?.discountBadge,
      discountDescription: displayPrice.discountInfo?.discountDescription,
      pricePerUnit: displayPrice.pricePerUnit,
      bestPrice: activeVariant.bestPrice,
      shouldDisplayFromPrice,
      fromPricePrefix
    }
  );
};
export {
  PriceSectionContainer
};
//# sourceMappingURL=PriceSectionContainer.js.map
